import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { Button, Typography, Box, useTheme, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../Dashboard/Header";

const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function BankReadDoc() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [dateRange, setDateRange] = useState({
    from: "",
    to: "",
  });

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [selectedIds, setSelectedIds] = useState([]);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  //========useEffect call get excel data ========

  useEffect(() => {
    const storedColumns = localStorage.getItem("columns");
    const storedRows = localStorage.getItem("rows");
    const savedDateRange = localStorage.getItem("dateRange");

    if (storedColumns) {
      setColumns(JSON.parse(storedColumns));
    }

    if (storedRows) {
      setRows(JSON.parse(storedRows));
    }

    if (savedDateRange) {
      setDateRange(JSON.parse(savedDateRange));
       console.log(JSON.parse(savedDateRange))
    }
  }, []);

  return (
    <Box mt="80px" ml="20px" mr="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Bank Reconciliation"
          subtitle="Auto Bank Reconciliation"
        />
        <Box display="flex"  gap={2}>
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[100],
            "&:hover": { backgroundColor: colors.blueAccent[700] },
          }}
        >
          Auto Match Transactions
        </Button>

        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[100],
            "&:hover": { backgroundColor: colors.blueAccent[700] },
          }}
        >
          Add Rules
        </Button>
        </Box>
      </Box>
      <Box display="flex" gap={2}>
        {/* excel data table */}

        <Box display="flex" flexDirection="column" height="78vh" width="50%">
          <Typography variant="h4">Excel Data</Typography>

          {rows.length > 0 && (
            <Box
              sx={{
                height: "76vh",
                width: "100%",
                overflowX: "auto",
                "& .MuiDataGrid-root": { border: "none" },
                "& .MuiDataGrid-cell": { border: "none", cursor: "pointer" },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: colors.blueAccent[700],
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: colors.blueAccent[700],
                },
                "& .MuiDataGrid-cell:focus": { outline: "none" },
                "& .ERDzoom-row:hover": {
                  transform: "scale(1.01)",
                  transition: "transform 0.2s ease-in-out",
                  zIndex: 1,
                  backgroundColor: colors.blueAccent[900],
                },
              }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                rowHeight={parseInt(preferences.rowHeight)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[20, 50, 100]}
                getRowClassName={() => "ERDzoom-row"}
                pagination
                checkboxSelection
                onSelectionModelChange={(newSelection) =>
                  setSelectedIds(newSelection)
                }
              />
            </Box>
          )}
        </Box>

        {/* tally data table */}

        <Box display="flex" flexDirection="column" height="78vh" width="50%">
          <Typography variant="h4">Tally Data</Typography>

          {rows.length > 0 && (
            <Box
              sx={{
                height: "76vh",
                width: "100%",
                overflowX: "auto",
                "& .MuiDataGrid-root": { border: "none" },
                "& .MuiDataGrid-cell": { border: "none", cursor: "pointer" },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: colors.blueAccent[700],
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: colors.blueAccent[700],
                },
                "& .MuiDataGrid-cell:focus": { outline: "none" },
                "& .ERDzoom-row:hover": {
                  transform: "scale(1.01)",
                  transition: "transform 0.2s ease-in-out",
                  zIndex: 1,
                  backgroundColor: colors.blueAccent[900],
                },
              }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                rowHeight={parseInt(preferences.rowHeight)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[20, 50, 100]}
                getRowClassName={() => "ERDzoom-row"}
                pagination
                checkboxSelection
                onSelectionModelChange={(newSelection) =>
                  setSelectedIds(newSelection)
                }
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
